var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addTranslations } from '@/config';
import { UMOTIF_API } from '@/routes';
import api from './instance';
const { CONFIG } = UMOTIF_API;
class ConfigService {
    getAppConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.get(CONFIG.GET_APP_CONFIG);
            yield addTranslations(data.languages);
            return data;
        });
    }
}
export default new ConfigService();
